export const PLATFORM_UI_ATTRIBUTE = 'platformUIAttribute';
export const THEME_SCHEME_ATTRIBUTE = 'themeUIAttribute';
export const THEME_BRAND_ATTRIBUTE = 'themeBrandAttribute';
